/**
 * User Register API
 * API communication only
 */

import { ApiBase } from "../../core/api-base";
import type * as z from "zod";
import { CreateUserPreRegistrationBody } from "../../api/generated/user_registers.zod";

export class UserRegisterApi extends ApiBase {
    public static async createPreRegistration(
        payload: z.infer<typeof CreateUserPreRegistrationBody>,
    ): Promise<Response> {
        return await super.apiPost("/api/v1/user-registers", payload, { noSpinner: true });
    }
}
